import { Container } from '@cgs/wge';
import { EndFreeSpinsPopupController } from './end-free-spins-popup.controller';
import { EndFreeSpinsPopupView } from './end-free-spins-popup.view';
import { BasePopupComponent } from '../base_popup_component';
import { EndFreeSpinsPopupParams } from './end-free-spins-popup.typings';

export class EndFreeSpinsPopupComponent extends BasePopupComponent<EndFreeSpinsPopupView> {
  protected _view: EndFreeSpinsPopupView;

  constructor(
    protected readonly container: Container,
    protected readonly params: Partial<EndFreeSpinsPopupParams> = {}
  ) {
    super(container, 'slot/popups/end_freespins/scene');

    this.createComponents();
  }

  protected createComponents() {
    this._view = new EndFreeSpinsPopupView(
      this.container,
      this.rootScene,
      this.popupScene,
      this.params
    );
    this.popupController = new EndFreeSpinsPopupController(this.container, this._view, this.params);
  }
}
